import * as PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import Select from 'antd/lib/select';
import { FormattedMessage } from 'react-intl';

import rule from './LanguageSwitcher.rule';

const Option = Select.Option;

const LanguageSwitcher = ({ languages, activeLanguage, changeLanguage }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <Select value={activeLanguage} onChange={changeLanguage}>
                {languages.map(lang => (
                    <Option key={lang} value={lang}>
                        <FormattedMessage id={`app.language.${lang}`} />
                    </Option>
                ))}
            </Select>
        </div>
    );
};
LanguageSwitcher.propTypes = {
    languages: PropTypes.arrayOf(PropTypes.string).isRequired,
    activeLanguage: PropTypes.string.isRequired,
    changeLanguage: PropTypes.func.isRequired,
};

export default LanguageSwitcher;
